import { ErrorBoundary } from './bugsnagUtils'; // eslint-disable-line import/order

import React from 'react';
import { render } from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';

import injectGoogleTagManager from './injectGoogleTagManager';
import App from './components/App';
import './styles/global.scss';
import './sprite.svg';

injectGoogleTagManager(process.env.FISHBRAIN_GOOGLE_TAG_MANAGER_ID);
injectGoogleTagManager(process.env.RBFF_GOOGLE_TAG_MANAGER_ID);

render(
  <ErrorBoundary>
    <Router>
      <App />
    </Router>
  </ErrorBoundary>,
  document.getElementById('root'),
);
